import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import LinkCell from "@isceco/widget-library2/basic-elements/List/cell/LinkCell.js";
import StringCell from "@isceco/widget-library2/basic-elements/List/cell/StringCell";

export default class VerordnungColumns {

  static getColumns() {
    return [
      VerordnungColumns.SR_NUMMER_COLUMN(),
      VerordnungColumns.GELTUNGSDAUER_COLUMN(),
      VerordnungColumns.ART_COLUMN(),
      VerordnungColumns.STATUS_COLUMN(),
      VerordnungColumns.LINK_COLUMN()
    ]
  }

  static SR_NUMMER_COLUMN() {
    return new StringColumn({
      key: 'srNummer',
      text: 'verordnung.table.header.srNummer',
      sortable: true
    })
  }

  static GELTUNGSDAUER_COLUMN() {
    return new StringColumn({
      key: 'geltungsdauer',
      text: 'verordnung.table.header.geltungsdauer',
      sortable: true
    })
  }

  static ART_COLUMN() {
    return new GenericColumn({
      key: 'kontArt',
      text: 'verordnung.table.header.art',
      cell: new StringCell({translate: true})
    })
  }

  static STATUS_COLUMN() {
    return new GenericColumn({
      key: 'kontStatus',
      text: 'verordnung.table.header.status',
      cell: new StringCell({translate: true})
    })
  }

  static LINK_COLUMN() {
    return new GenericColumn({
      key: 'link',
      text: 'verordnung.table.header.link',
      cell: new LinkCell({
        noText: true,
        target: '_blank',
        url: row => row.link?.indexOf(':') >= 0 ? row.link : `https://${row.link}`,
        icon: 'arrow alternate circle down outline icon'
      })
    })
  }
}
